import { useCESDK } from './useCESDK';

// useCustomizeCESDK.js
// -----------------------------------------------------------------------------
// This hook provides a dedicated CESDK instance for the template customizer
// screens (e.g. /customize/:templateId).  It simply wraps the existing
// `useCESDK` implementation so we avoid any risk of altering the core editor
// logic that other parts of the application rely on.  If, in the future, the
// customizer needs CESDK-specific tweaks, they can be applied here without
// touching the shared hook.
// -----------------------------------------------------------------------------

export function useCustomizeCESDK() {
  // Currently we just forward all behaviour.  Having a separate wrapper keeps
  // the door open for custom tweaks while guaranteeing full feature-parity
  // (and stability) with the proven implementation.
  return useCESDK();
} 